var PaymentModeModificationView = $.extend({/* PaymentModeModificationView */}, BaseView, {

	viewSelector: '#payment-mode-modification-view',

	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {

		$(this.viewSelector).find('.main-options > label').click((function (event) {

			$(this.viewSelector).find('.payment-options-type').addClass('hide');
			$(this.viewSelector).find('[name=percentage-input]').parent().addClass('hide');
			$(this.viewSelector).find('[name=percentage-input]').prop('disabled', true);

			if ($(event.currentTarget).attr('for') == 'type-fee') {
				$(this.viewSelector).find('.payment-options-type').removeClass('hide');
			} else if ($(event.currentTarget).attr('for') == 'type-percentage') {
				$(this.viewSelector).find('[name=percentage-input]').parent().removeClass('hide');
				$(this.viewSelector).find('[name=percentage-input]').prop('disabled', false);
			}

		}).bind(this));

		$(this.viewSelector).find('.secondary-options label.with-input').click((function(event) {

			if ($(event.currentTarget).attr('for') == 'amount-fee') {
				$(event.currentTarget).find('input').prop('disabled', false);
				$(event.currentTarget).find('input').focus();
			} else {
				$(event.currentTarget).find('input').prop('disabled', true);
			}

		}).bind(this));

		$(this.viewSelector).find('[name=amount-input]').focus((function (event) {
			$(event.currentTarget).parent().siblings('input').prop('checked', true);
		}).bind(this));
	}
})